import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import ExternalLinkService from '../../services/ExternalLinkService';
import homeIcon from '../../assets/ic_home.svg';
import teamIcon from '../../assets/ic_profile.svg';
import mangaIcon from '../../assets/ic_collection.svg';
import chapterIcon from '../../assets/ic_play_white.svg';
import rulesIcon from '../../assets/ic_info.svg';

const NAV_ITEMS = [
    { to: '/manga/studio', label: 'Главная', icon: homeIcon, exact: true },
    { to: '/manga/studio/team', label: 'Команда', icon: teamIcon },
    { to: '/manga/studio/manga', label: 'Манга', icon: mangaIcon },
    { to: '/manga/studio/chapters', label: 'Главы', icon: chapterIcon },
    { to: '/manga/rules', label: 'Правила', icon: rulesIcon, exact: true },
];

const TG_AUTHORS_LINK = 'https://t.me/animixauthors';

const MangaStudioNav = ({ showBanner = false }) => {
    const location = useLocation();

    return (
        <div className="manga-studio-nav-wrapper">
            <nav className="ui-chips manga-studio-nav" aria-label="Разделы студии">
                {NAV_ITEMS.map((item) => {
                    const isActive = item.exact
                        ? location.pathname === item.to
                        : location.pathname.startsWith(item.to);
                    return (
                        <Link
                            key={item.to}
                            to={item.to}
                            className={`ui-chip manga-studio-nav-item ${isActive ? 'is-active' : ''}`}
                            aria-current={isActive ? 'page' : undefined}
                        >
                            <img src={item.icon} alt="" aria-hidden="true" />
                            <span>{item.label}</span>
                        </Link>
                    );
                })}
            </nav>
            {showBanner ? (
                <div className="manga-studio-banner">
                    <div className="manga-studio-banner-body">
                        <div className="manga-studio-banner-title">animix с авторами</div>
                        <div className="manga-studio-banner-text">
                            Новости, гайды и советы для авторов контента.
                        </div>
                    </div>
                    <a
                        className="manga-studio-banner-link"
                        href={TG_AUTHORS_LINK}
                        onClick={(event) => {
                            event.preventDefault();
                            ExternalLinkService.openExternal(TG_AUTHORS_LINK);
                        }}
                    >
                        t.me/animixauthors
                    </a>
                </div>
            ) : null}
        </div>
    );
};

export default MangaStudioNav;
